import Vue from 'vue';
import VueI18n from 'vue-i18n';
import enMess from './lang/en.json';

Vue.use(VueI18n);

const messages = {
  en: enMess
};

export default new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages
});
